export function verifySemver(
  current: string | undefined | null,
  required: string
) {
  if (current === undefined) {
    return "unknown";
  }
  if (current === null) {
    return "invalid";
  }

  const compare = compareSemver(current, required);
  return compare >= 0 ? "valid" : "invalid";
}

function compareSemver(a: string, b: string) {
  const pa = a.split(".").map(Number);
  const pb = b.split(".").map(Number);
  for (let i = 0; i < 3; i++) {
    if ((pa[i] ?? 0) !== (pb[i] ?? 0)) {
      return (pa[i] ?? 0) - (pb[i] ?? 0);
    }
  }
  return 0;
}
